import React from "react";

const PageNotFound = () => (
  <section className="notFound" id="notFound">
    <h2>Oops! Page not found.</h2>
  </section>
);

export default PageNotFound;
